import React from 'react';

export interface ParagraphProps {
    text: string; // Array of image URLs
}

export const Paragraph: React.FC<ParagraphProps> = (props) => {
    const { text } = props;

    return (
        <div className='text-gray-950 text-md font-normal '>
            {text}
        </div>
    );
};